module.exports = __webpack_public_path__ + "static/media/ic-n-i-c-a-logo-small.99aa89ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-n-i-c-a-logo-small.svg
// module id = 783
// module chunks = 0